// Shared component styles. Preserve selector order, style values, and caller overrides.
export const popupFilterInputSx = (accentColor = "#9C4FFF") => ({
  "& .MuiOutlinedInput-root": {
    minHeight: 48,
    borderRadius: "12px",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    fontSize: 13,
    boxShadow: "0 1px 2px rgba(16, 24, 40, 0.06)",
    "& fieldset": {
      borderColor: "#D0D5DD"
    },
    "&:hover fieldset": {
      borderColor: "#CBD5E1"
    },
    "&.Mui-focused fieldset": {
      borderColor: accentColor,
      borderWidth: 2
    }
  },
  "& .MuiAutocomplete-inputRoot": {
    alignItems: "center",
    pr: "12px !important",
    py: "3px !important"
  },
  "& .MuiOutlinedInput-input": {
    boxSizing: "border-box",
    padding: "10px 12px",
    fontSize: 13,
    fontFamily: "Be Vietnam Pro",
    color: "#475467"
  },
  "& .MuiAutocomplete-input": {
    minWidth: "0 !important",
    fontSize: 13,
    fontFamily: "Be Vietnam Pro",
    color: "#475467",
    padding: "10px 4px 10px 12px !important"
  },
  "& .MuiInputBase-input::placeholder": {
    color: "#98A2B3",
    opacity: 1
  }
});
export const popupFilterChipSx = {
  height: 28,
  borderRadius: "999px",
  backgroundColor: "#EAF2FF",
  color: "#3451F4",
  fontWeight: 500,
  fontSize: 13,
  fontFamily: "Be Vietnam Pro",
  "& .MuiChip-label": {
    px: 1.4
  },
  "& .MuiChip-deleteIcon": {
    color: "#3451F4",
    fontSize: 18,
    mr: 0.5,
    "&:hover": {
      color: "#1D4ED8"
    }
  }
};
export const multiSelectStyles = {
  root: () => ({
    display: "flex",
    flexDirection: "column"
  }),
  chips: ({
    chipsBelow
  }) => ({
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
    order: chipsBelow ? 1 : 0,
    mt: chipsBelow ? 1.4 : 0,
    mb: chipsBelow ? 0 : 1.4
  }),
  chip: ({
    chipSx
  }) => [popupFilterChipSx, chipSx],
  option: () => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
    "&[aria-selected='true']": {
      backgroundColor: "#F4EBFF !important",
      color: "#7C3AED",
      fontWeight: 700
    }
  }),
  optionContent: () => ({
    display: "flex",
    alignItems: "center",
    gap: 1
  }),
  selectedMark: () => ({
    color: "#7C3AED",
    fontWeight: 800
  }),
  input: ({
    inputSx,
    textFieldProps
  }) => [popupFilterInputSx(), inputSx, textFieldProps?.sx]
};
